export default __webpack_public_path__ + "static/media/reaction001.94ea165c.png";